 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Contra Document No
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryContraDocNoFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryContraDocNoFilterForm"
                            v-model="filtersContraDocNo.contraDocNo"
                            :label="filtersContraDocNoLabel.contraDocNo"
                            :error-messages="errors.collect('filterContraDocNo')"
                            data-vv-name="filterContraDocNo"
                            :data-vv-as="filtersContraDocNoLabel.contraDocNo"
                            v-validate="'entry|max:20'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearContraDocNoFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doContraDocNoFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="contraDocNoHeaders"
          :items="contraDocNoItems"
          v-bind:options.sync="paginationContraDocNo"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsContraDocNo"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.docNo }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignContraDocNo(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { accountsFilters } from '@/mixins/accounting/accountsFilters'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      actionName: '',
      paginationContraDocNo: {
        page: 1
      }
    }
  },
  mounted() {
    this.doClearContraDocNoFilters()
  },
  methods: {
    closeDialog() {
      this.filtersContraDocNo.contraDocNo = ''
      this.$emit('close')
    },
    doClearContraDocNoFilters() {
      this.filtersContraDocNo.contraDocNo = ''
      this.fetchContraDocNoData()
    },
    doContraDocNoFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryContraDocNoFilterForm').then((result) => {
        if (result) {
          this.paginationContraDocNo.page = 1
          this.fetchContraDocNoData()
        }
      })
    },
    assignContraDocNo(data) {
      // Use $emit to call parent GL Account No page method assignGlAcctNo and pass the value
      this.$emit('assign-contra-doc-no', data.docNo)
      this.$emit('close')
    }
  },
  computed: {},
  mixins: [TableConst.default, accountsFilters, commonAjaxMixin]
}
</script>
